import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Backdrop from 'reakit/Backdrop';
var Backdrop = styled(_Backdrop).withConfig({
  displayName: "styled__Backdrop",
  componentId: "sc-13cr5qa-0"
})(["background-color:black;opacity:0.6;&{", ";}"], theme('fannypack.Backdrop.base'));
export default Backdrop;
export { Backdrop };